import useSWRImmutable  from 'swr/immutable'
import authAxios from '../../helpers/authAxios'
import { Employee, Employees, remoteTeamAssignee } from '../Team/api';


export type Clients = {
    _id: string;
    client_name: string
}


export type ClientList = {
    client_incharge: any;
    client_contact: any;
    _id: string;
    client_name: string;
    profilepic: string;
    client_type: string;
    website: string;
    location: string;
    projects:any;
}

export type ClientForm = {
    _id?: string;
    client_name: string,
    profilepic?: string;
    client_type: string;
    website: string;
    location: string;
    client_contact?:ClientContactForm[];
    client_incharge?:EmployeeDetailsForClient[];

}

export type ClientInChargeForm = {
    client_incharge: any;
    _id?: string;
    profilepic:string;
    name: string;
    mail_id: string,
    phone_number: string 
}

export type ClientContactForm = {
    client_contact: any;
    _id?: string;
    profilepic?: string;
    name: string,
    role: string;
    mail_id: string;
    phone_number: string;
}

export type ClientType = {
    _id: string;
    name: string
}

export type EmployeeDetailsForClient = {
    name:string;
    email_id:string;
    profilepic?:string;
    phonenumber:string;

}

export type EmployeeType = {
    name: string;
    email_id: string;
    uan_number: string;
    esi_number: string;
    marital_status: string;
    mother_name: string;
    father_name: string;
    gender: string;
    _id: string;
    profilepic?: string;
    profile: {
        training_video: string; first_name: string, last_name: string, email_id: string, isactive_user: boolean
};
    role: {_id: string, role_name: string};
    designation: {_id: string, name: string};
    department: {_id: string, name: string};
    type: string;
    skype_id: string;
    date_of_birth: string;
    date_of_joining: string;
    phonenumber: string;
    alternative_phonenumber: string;
    address: string;
    personal_emailId:string;
    linkedIn_id:string;
    bank_details : string,
    pan_number : string,
    aadhar_number : string,
    employee_number:string,
}

const getClientList = (url: string): Promise<Clients[]> => authAxios.get(url).then((resp): Clients[] => {
    const result = resp.data?.data
    return result
})

const getClientDetails = (url: string): Promise<ClientList> => authAxios.get(url).then((resp): ClientList => {
    const result = resp.data?.data
    return result
})
const getClientTypeList = (url: string): Promise<ClientType[]> => authAxios.get(url).then((resp): ClientType[] => {
    const result = resp.data?.data
    return result
})

export const getImageFileUrl = (formData: any) => authAxios.post('/attachments/files/single', formData).then(resp => resp.data )

export const createClient = (formData: ClientForm) => authAxios.post('/clients', formData).then( resp => resp.data )

export const updateClient = (clientId: string, formData: ClientForm) => authAxios.put(`/clients/${clientId}`, formData)

export const deleteClient = (clientId: string) => authAxios.delete(`/clients/${clientId}`)

export const updateClientInCharge = (clientId: string, formData: ClientInChargeForm) => authAxios.put(`/clients/clientincharge/${clientId}`, formData)

export const updateClientContact = (clientId: string, formData: ClientContactForm) => authAxios.put(`/clients/clientcontact/${clientId}`, formData)

export const useClientList =  () => {
    const { data, error, mutate } = useSWRImmutable('/clients/list', getClientList)
    return {
        clientsList: data,
        isLoading: !error && !data,
        isError: error,
        clientListMutate: mutate
    }    
}

export const useClientDetails = (clientId: string | undefined) => {
    const { data, error ,mutate} = useSWRImmutable( clientId ?`/clients/${clientId}`: null, getClientDetails)
    return {
        clientsDetails: data,
        isLoading: !error && !data,
        isError: error,
        clientDetailsMutate: mutate
    }
}

export const useProjectDetailsByClient = (clientId: string | undefined) => {
    const { data, error ,mutate} = useSWRImmutable( clientId ?`/clients/projects/${clientId}`: null, getClientDetails)
    return {
        projectDetailsByClient: data,
        isLoading: !error && !data,
        isError: error,
    }
}
export const useClientTypeList = () => {
    const { data, error } = useSWRImmutable('/clients/clienttype', getClientTypeList)
    return {
        clientTypeList: data,
        isLoading: !error && !data,
        isError: error
    }
}

const getEmployeeList = (url:string): Promise<Employees[]> => authAxios.get(url).then( resp  => { 
    const assignees = resp.data?.data 
    return assignees.map( (person: remoteTeamAssignee) =>  new Employee(person) )
})

export const useEmployeeList = (teamId: string, roleId: string) => {
    const { data, error, mutate } = useSWRImmutable(`/departments/${teamId}/${roleId}`, getEmployeeList)
    return {
        employeesList: data || [],
        isEmployeesLoading: !error && !data,
        isEmployeesError: error,
        employeeListMutate: mutate
    }
}







